<template>
    <b-card :title="title">
        <b-card-header>
            <export-details-dialog :query-data="query" ref="detailsDialog" />
            <b-row>
                <b-col cols="4">
                    <b-form-select
                        id="input-order-item-type"
                        v-model="filters.order_item_type_id"
                        :options="types"
                        text-field="name"
                        value-field="id"
                    >
                        <template #first>
                            <b-form-select-option :value="null">
                                Select Any Type
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col cols="4">
                    <b-form-input
                        type="search"
                        placeholder="Search Master Items..."
                        v-model="query"
                        @input="updateQuery"
                    ></b-form-input>
                </b-col>
                <b-col>
                    <slot></slot>
                </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
            <p class="mt-3">
                Page: {{ pagination.page }} of {{ pageCount }} Total:
                {{ pagination.total }}
            </p>
            <b-table
                :fields="itemFields"
                striped
                hover
                responsive
                :items="items"
            >
                <template #cell(id)="row">
                    <b-button
                        size="sm"
                        @click="viewItem(row.item.id)"
                        v-if="user_permissions.includes('view.master.items')"
                        class="mr-2"
                        variant="primary"
                    >
                        View
                    </b-button>
                </template>
            </b-table>
            <b-row>
                <b-col>
                    <b-pagination
                        class="float-right"
                        v-model="pagination.page"
                        :total-rows="pagination.total"
                        :per-page="pagination.pageSize"
                        aria-controls="assetTable"
                        pills
                        align="right"
                    ></b-pagination>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>

<script>
import _ from 'lodash'
import popupMixins from '@/mixins/popupMixins'
import ExportDetailsDialog from './ExportDetailsDialog'

export default {
    name: 'ListItems',
    props: ['type', 'title'],
    mixins: [popupMixins],
    components: {
        ExportDetailsDialog,
    },
    data() {
        return {
            filters: {
                order_item_type_id: null,
            },
            query: '',
            page: 1,
            itemFields: [
                {
                    key: 'id',
                    label: '',
                    stickyColumn: true,
                },
                'name',

                {
                    key: 'ext_reference_code',
                    label: 'Code',
                },
                {
                    key: 'order_item_type_id',
                    label: 'Type',
                    formatter: (value, key, item) =>
                        item.type && item.type.name,
                },
                {
                    key: 'vendor_id',
                    label: 'Vendor',
                    formatter: (value, key, item) =>
                        item.vendor && item.vendor.name,
                },

                {
                    key: 'ext_reference_code',
                    label: 'Code',
                    formatter: (value, key, item) => item.ext_reference_code,
                },

                {
                    key: 'uom',
                    label: 'UOM',
                    formatter: (value, key, item) => item.uom,
                },
                {
                    key: 'selling_price',
                    label: 'Price',
                    formatter: (value, key, item) => item.selling_price,
                },
            ],
        }
    },

    mounted() {
        console.log('items', this.items)
        if (this.$route.query.query) this.query = this.$route.query.query
        this.doSearch()
    },
    computed: {
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
        items() {
            return this.$store.state.masterItem.items
        },
        pagination() {
            return this.$store.state.masterItem.pagination || {}
        },
        user() {
            return this.$store.state.user
        },
        permissions() {
            return this.$store.state.rolePermissions
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
        types() {
            return this.$store.state.itemType.items.filter(x => !x.is_discount)
        },
    },
    watch: {
        'pagination.page': function (newPage) {
            this.changePage(newPage)
        },
        filters: {
            handler: function (filters) {
                console.log('filters', filters)
                this.doSearch()
            },
            deep: true,
        },
    },

    methods: {
        showDetailsDialog() {
            this.$refs.detailsDialog.show(this.queryModel)
        },
        viewItem(id) {
            const path = `${this.$route.path}/${id}`
            this.$router.push({ path })
        },
        updateQuery: _.debounce(function (query) {
            this.query = query
            this.$router.push({ query: { query: this.query } })
            this.doSearch()
        }, 200),
        changePage: function (page) {
            this.page = page
            this.$router.push({ query: { page: page } })
            this.doSearch()
        },
        doSearch() {
            let { query, page, filters } = this
            if (!parseInt(filters.order_item_type_id, 10)) {
                filters.order_item_type_id = null
            }
            this.$store.dispatch('masterItem/fetch', {
                query,
                page,
                filters,
            })
        },
        deleteItem(id) {
            let item = this.items.find(el => el.id == id)

            const title = 'Delete Master Item?'
            const message = `Are you sure you want to delete ${item.name}?`
            this.confirmMessage(title, message).then(result => {
                if (result) {
                    this.$store
                        .dispatch('masterItem/delete', id)
                        .then(() => {
                            this.doToast(
                                'Deleted!',
                                'Your Item has been deleted.',
                                'success'
                            )
                        })
                        .catch(error => {
                            console.error(error)
                            this.doToast(
                                'Error!',
                                'Unable to delete item!',
                                'danger'
                            )
                        })
                }
            })
        },
    },
}
</script>
<style></style>
